import { connect } from 'react-redux';

import { logout } from '../../redux';
import Logout from './Logout.state';

const mapDispatchToProps = {
  onLogout: logout,
};

export default connect(
  null,
  mapDispatchToProps,
)(Logout);



// WEBPACK FOOTER //
// ./src/modules/auth/components/Logout/Logout.connect.jsx